<template>
  <div class="ws-main" :style="{ 'max-width': maxWidth }" :class="{ 'pb-240px': pb240px }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    maxWidth: {
      type: String,
    },
    pb240px: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
@import '../assets/scss/ws-main.scss';
</style>
